import React from "react";
import "./header.css";
import bnbcry from "../../asset/bnbcry.png";
// import login from "../../asset/login.svg";

const Header = () => {
  return (
    <>
      <nav class="navbar navbar-expand-lg" data-bs-theme="dark">
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            <img src={bnbcry} alt="" />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/">
                  Home
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/About">
                  About Us
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/Contact">
                  Contact Us
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/FaqPage">
                  FAQ
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/Login">
                  Login
                </a>
              </li>
            </ul>
            <form>
              <a href="/Signup">
                <button class="btn btn-dark" type="submit">
                  Sign-Up
                </button>
              </a>
            </form>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
